<template>
  <CustomTooltip>
    <button
      v-bind="$attrs"
      ref="btnRef"
      type="button"
    >
      <img :src="CancelIcon" alt="">
    </button>

    <template #content>
      <span>Cancel</span>
      <kbd class="bg-white text-black-50 ml-1">esc</kbd>
    </template>
  </CustomTooltip>
</template>

<script>
import { onKeyStroke } from '@vueuse/core'
import { ref } from 'vue'
import CustomTooltip from '@/components/custom-tooltip.vue'
import { CancelIcon } from '../../../common/icons'

export default {
  name: 'WebcamRecorderCancelRecordingButton',
  components: { CustomTooltip },
  inheritAttrs: false,
  setup() {
    const btnRef = ref(null)

    onKeyStroke('Escape', () => {
      btnRef.value?.click()
    })

    return {
      btnRef,
      CancelIcon,
    }
  },
}
</script>
